module.exports = __webpack_public_path__ + "web/img/level-2.7821708c.png";